import { useMediaQuery } from "@mui/material";
import { MetaTag } from "@src/utils/types/meta";
import Head from "next/head";

const OnepointHeader = (props: MetaTag) => {
	const { meta } = props;

	const isMobile = useMediaQuery("(max-width: 768px)");

	return (
		<Head>
			<title>{meta?.metaTitle || "탑티어 마케터 파트타임 고용 서비스 - 원포인트"}</title>
			<meta title={meta?.metaTitle || "탑티어 마케터 파트타임 고용 서비스 - 원포인트"} />
			<meta
				name="description"
				content={
					meta?.metaDescription ||
					"원포인트(One Point)는 업계 탑티어 마케터를 파트타임으로 고용할 수 있는 HR 서비스입니다."
				}
			/>
			<meta property="og:type" content={meta?.metaOgType || "website"} />
			<meta
				property="og:title"
				content={meta?.metaOgTitle || "탑티어 마케터 파트타임 고용 서비스 - 원포인트"}
			/>
			<meta
				property="og:description"
				content={
					meta?.metaOgDescription ||
					"원포인트(One Point)는 업계 탑티어 마케터를 파트타임으로 고용할 수 있는 HR 서비스입니다."
				}
			/>
			<meta
				property="og:image"
				content={meta?.metaOgImage || "/static/image/metadata/thumbnail0424.png"}
			/>
			<meta property="og:url" content={meta?.metaOgUrl || "https://www.1point.kr"} />
			<meta property="twitter:card" content={meta?.metaTwitterCard || "summary"} />
			<meta
				property="twitter:title"
				content={meta?.metaTwitterTitle || "탑티어 마케터 파트타임 고용 서비스 - 원포인트"}
			/>
			<meta
				property="twitter:description"
				content={
					meta?.metaTwitterDescription ||
					"원포인트(One Point)는 업계 탑티어 마케터를 파트타임으로 고용할 수 있는 HR 서비스입니다."
				}
			/>
			<meta
				property="twitter:image"
				content={meta?.metaTwitterImage || "/static/image/metadata/thumbnail0424.png"}
			></meta>
			<meta content="summary_large_image" name="twitter:card" />
			<meta
				content="_i2TfPGLIkr_zAdy5F8YHNo_Bzt72Z_R38hrs4WjIvI"
				name="google-site-verification"
			></meta>
			<link rel="apple-touch-icon" sizes="57x57" href="/favicon/apple-icon-57x57.png" />
			<link rel="apple-touch-icon" sizes="60x60" href="/favicon/apple-icon-60x60.png" />
			<link rel="apple-touch-icon" sizes="72x72" href="/favicon/apple-icon-72x72.png" />
			<link rel="apple-touch-icon" sizes="76x76" href="/favicon/apple-icon-76x76.png" />
			<link rel="apple-touch-icon" sizes="114x114" href="/favicon/apple-icon-114x114.png" />
			<link rel="apple-touch-icon" sizes="120x120" href="/favicon/apple-icon-120x120.png" />
			<link rel="apple-touch-icon" sizes="144x144" href="/favicon/apple-icon-144x144.png" />
			<link rel="apple-touch-icon" sizes="152x152" href="/favicon/apple-icon-152x152.png" />
			<link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-icon-180x180.png" />
			<link
				rel="icon"
				type="image/png"
				sizes="192x192"
				href="/favicon/android-icon-192x192.png"
			/>
			<link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
			<link rel="icon" type="image/png" sizes="96x96" href="/favicon/favicon-96x96.png" />
			<link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
			<link rel="manifest" href="/manifest.json" />
			<meta name="msapplication-TileColor" content="#ffffff" />
			<meta name="msapplication-TileImage" content="/favicon/ms-icon-144x144.png" />
			<meta name="theme-color" content="#ffffff"></meta>
			{isMobile ? (
				<meta
					name="viewport"
					content="viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
				/>
			) : (
				<meta name="viewport" content="width=device-width"></meta>
			)}
			<meta name="format-detection" content="telephone=no"></meta>
			{process.env.NEXT_PUBLIC_NODE_VALUE !== "prod" && (
				<meta name="robots" content="noindex, nofollow" />
			)}
		</Head>
	);
};

export default OnepointHeader;
